import { Color } from 'theme/style';

export default {
  root: {
    color: Color.Text,
    minWidth: '25px'
  }
};
